module.exports = __webpack_public_path__ + "img/12-1.3407a7c7.png";